<div class="pedido-drp-view">
    <div class="table-responsive">
        <table class="table table-striped table-hover table-bordered">
            <thead>
                <tr>
                    <th class="col-title">D.R.P</th>
                    <th class="col-valor text-right">R$</th>
                    <th class="col-perc text-right" *ngIf="config.canShowColPerc"
                        sgtTooltip="Participação % — sobre o valor total líquido">Part. %</th>
                    <th class="col-perc-composicao text-right" *ngIf="config.canShowColPercComposicao"
                        sgtTooltip="Composição % — sobre o valor total bruto">Comp. %</th>
                </tr>
            </thead>
            <tbody *ngIf="drp">
                <tr *ngFor="let linha of linhas"
                    [class.row-componente]="linha.nivel === 'componente'"
                    [class.row-pedido-lucro-liquido-abaixo]="linha.slug === 'lucro-liquido' && drp.percLucroLiquidoAbaixo"
                    [class.row-pedido-lucro-liquido-acima]="linha.slug === 'lucro-liquido' && !drp.percLucroLiquidoAbaixo">
                    <td class="col-title" [sgtTooltip]="linha.legenda || tituloCompleto(linha)">
                        <span *ngIf="linha.numero && config.canShowDRPCustos">{{linha.numero}}</span>
                        {{linha.titulo}}
                    </td>
                    <td class="col-valor text-right" title="{{drp[linha.campoValor] | currencyFormat:1:2:2}}">
                        {{drp[linha.campoValor] | currencyFormat:1:2:2}}
                    </td>
                    <td class="col-perc text-right" *ngIf="config.canShowColPerc" [title]="participacao(linha)">
                        {{participacao(linha)}}
                    </td>
                    <td class="col-perc-composicao text-right" *ngIf="config.canShowColPercComposicao" [title]="composicao(linha)">
                        {{composicao(linha)}}
                    </td>
                </tr>
                <!-- 9. QUALIDADE DE VALOR (QV) -->
                <tr *ngIf="config.canShowQV">
                    <td class="col-title" title="9. QUALIDADE DE VALOR (QV)">
                        <span *ngIf="config.canShowDRPCustos">
                            9.
                        </span>
                        QUALIDADE DE VALOR (QV)
                    </td>
                    <td class="col-escala-grupo-rentabilidade text-center" colspan="3">
                        <sgt-escala-rentabilidade
                            [id]="drp.escalaGrupoRentabilidade"
                            [showText]="true">
                        </sgt-escala-rentabilidade>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
